var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75001 19H16.2053C17.1965 19 17.9903 18.1958 17.8925 17.2095C17.6163 14.4266 16.6307 9.15923 13.1143 7H8.21895C7.7732 7.27371 7.36813 7.59737 7 7.95957",
    stroke: "currentColor",
    strokeWidth: 1.79472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6121 3.25716L13.2857 3.4L10.7551 3.03663C10.5859 3.01233 10.4141 3.01233 10.2449 3.03663L7.71427 3.4L6.38792 3.25716C5.56247 3.16827 5.06933 4.15159 5.63426 4.75998L7.71427 7H13.2857L15.3657 4.75998C15.9307 4.15159 15.4375 3.16827 14.6121 3.25716Z",
    stroke: "currentColor",
    strokeWidth: 1.79472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 12H4.25C3.55964 12 3 12.5596 3 13.25V13.25C3 13.9404 3.55964 14.5 4.25 14.5H5.75C6.44036 14.5 7 15.0596 7 15.75V15.75C7 16.4404 6.44036 17 5.75 17H3.4",
    stroke: "currentColor",
    strokeWidth: 1.79472,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12V11",
    stroke: "currentColor",
    strokeWidth: 1.79472,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18V17",
    stroke: "currentColor",
    strokeWidth: 1.79472,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvIcon);
export default __webpack_public_path__ + "static/media/ctv-icon.4267b210f5fe2ebaaa378a861178e5ad.svg";
export { ForwardRef as ReactComponent };